import styled from 'styled-components';
import { Typ51, Typ35 } from 'dc/Typ';
import IcoW01 from 'dc/IcoW01';

type WrapperProps = {
  color: string;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${props => props.color || '#007079'};
  padding-left: 16px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Typ51)``;

export const SubHeader = styled(Typ35)`
  margin-top: 4px;
`;

export const Icon = styled(IcoW01)``;
